import { FSCustomerAuth } from './_auth';

export class FSCustomer {
  static doc = {
    getByAuth: FSCustomerAuth._getDocByAuth,
    getByDocID: FSCustomerAuth._getDocByID,
    getID: FSCustomerAuth._getDocID,
  };
}
